import * as uamFlowTypes from './uamFlowTypes';
import {selectIsAutoCleanInProgress, selectIsFindMyDeviceInProgress} from '../../state/selectors/iotData';

export const ACTIVATE = 'activate';
export const DEACTIVATE = 'deactivate';
export const REFRESH_INFO = 'refreshInfoBatch';
export const UPDATE_SETTING = 'updateSetting';
export const FIRMWARE_UPGRADE = 'firmwareUpgrade';
export const PROGRESS = 'progress';
export const RUN_COMMAND = 'runCommand';
export const COLLECT_DATA = 'collectData';
export const DATA_COLLECTION = 'dataCollection';
export const RESET_DEVICE = 'resetDevice';

export const getUamFlowTypes = (actionType) => {
    switch (actionType) {
        case COLLECT_DATA:
        case DATA_COLLECTION:
            return uamFlowTypes.DATA_COLLECTION;
        case REFRESH_INFO:
            return uamFlowTypes.SYNCHRONIZE;
        case FIRMWARE_UPGRADE:
            return uamFlowTypes.UPDATE_FIRMWARE;
        case UPDATE_SETTING:
            return uamFlowTypes.UPDATE_SETTINGS;
        case RESET_DEVICE:
            return uamFlowTypes.RESET_DEVICE;
        case RUN_COMMAND:
            const isAutoCleanInProgress = selectIsAutoCleanInProgress();

            if (isAutoCleanInProgress) return uamFlowTypes.AUTO_CLEAN;

            const isFindMyDeviceInProgress = selectIsFindMyDeviceInProgress();

            if (isFindMyDeviceInProgress) return uamFlowTypes.FIND_MY_DEVICE;
            return;
        default:
            return;
    }
};
